module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Benutzerverwaltung","select":"Benutzer","logout":"Abmeldung","home":"Home","suppliers":"Lieferanten","intern":"Intern"},"en":{"title":"User management","select":"User","logout":"Logout","suppliers":"Suppliers","intern":"Intern"},"nl":{"title":"Gebruikersbeheer","select":"Gebruiker","logout":"Afmelden","suppliers":"Leveranciers","intern":"Intern"}}')
  delete Component.options._Ctor
}
